import React from "react";
import ReactSVG from "react-svg";
import ExternalLink from "~/assets/img/icon/link-extern.svg";
import { Margin, Text } from "~/components/elements";
import * as S from "./styles";

export default function PdfPreview({ fileSrc, imageSrc, alt, showDownload = true }) {
  return (
    <>
      <Margin mb={2}>
        <S.PdfHolder>
          {showDownload && (
            <Margin mb={2} className="download-text-container">
              <Text
                level={"2"}
                emphasis={false}
                primary
                className="download-text"
              >
                Faça o download do regulamento{" "}
                <a href={fileSrc} download>
                  aqui
                </a>
                .
              </Text>
            </Margin>
          )}
          <S.IconExternalLink>
            <a
              href={fileSrc}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ReactSVG src={ExternalLink} />
            </a>
          </S.IconExternalLink>
          <a
            href={fileSrc}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={imageSrc} alt={alt} />
          </a>
        </S.PdfHolder>
      </Margin>
    </>
  );
}
